const SESSION_KEY = 'rb_intake_match'

export function loadMatchSession() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY)
    if (!raw) {
      return null
    }
    const match = JSON.parse(raw)
    if (match && Array.isArray(match.people)) {
      // Old browser drafts may predate the public projection fix. This exact
      // fixture marker is provenance, never a clinician's public role.
      match.people = match.people.map(person => person && person.title === 'QA10_ANXIETY_20261024'
        ? {...person,title:''} : person)
    }
    return match
  } catch (e) {
    return null
  }
}

export function saveMatchSession(patch) {
  const next = Object.assign({}, loadMatchSession() || {}, patch)
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(next))
  return next
}

export function clearMatchSession() {
  sessionStorage.removeItem(SESSION_KEY)
}

/** Invalidate only the offer belonging to the current intake/snapshot/receipt. */
export function invalidateMatchSession(context = {}) {
  const match = loadMatchSession()
  if (!match) return false
  const same = (a,b) => a != null && b != null && String(a) === String(b)
  if (same(context.recommendationId,match.recommendationId)
      || same(context.snapshotId,match.snapshotId)
      || same(context.snapshotId,match.pendingMatchRunSnapshotId)
      || same(context.intakeId,match.screeningIntakeId)) {
    clearMatchSession()
    return true
  }
  return false
}

export function getSessionPerson(therapistId) {
  const session = loadMatchSession()
  if (!session || !Array.isArray(session.people)) {
    return null
  }
  const id = String(therapistId)
  return session.people.find((p) => String(p.id) === id) || null
}

export function hasSandboxMatchSession() {
  const session = loadMatchSession()
  return !!(session && session.recommendationId && Array.isArray(session.people) && session.people.length)
}
